/**
 * Port of Python's SequenceMatcher.quick_ratio()
 * Calculates a quick ratio similarity metric between two strings.
 */
function quickRatio(a, b) {
  const len1 = a.length;
  const len2 = b.length;
  const length = len1 + len2;

  if (length === 0) return 1.0;

  // Count matching characters
  const matches = {};
  [...a].forEach(char => {
    matches[char] = (matches[char] || 0) + 1;
  });

  let matchCount = 0;
  [...b].forEach(char => {
    if (matches[char] && matches[char] > 0) {
      matchCount += 1;
      matches[char] -= 1;
    }
  });

  return (2.0 * matchCount) / length;
}

export { quickRatio as getStringSimilarity };
